<template>
  <div class="w-full h-full relative">
    <div v-if="isLoading" class="absolute w-full top-0 left-0 h-full">
      <vue-element-loading
        :active="isLoading"
        spinner="spinner"
        duration="1.5"
        color="#4f4f4f"
        size="50"
      />
    </div>
    <folders-empty v-if='foldersEmptyList'/>
    <folders-list v-else @isEmptyList="folderEmpty"/>
  </div>
</template>

<script>
import FoldersEmpty from '@/modules/Folders/components/FoldersEmpty'
import FoldersList from '@/modules/Folders/components/FoldersList'
import VueElementLoading from "vue-element-loading";
import useFolderState from '@/modules/Folders/hooks/useFolderState'
const {
  state: paginationStore,
  setPagination
} = useFolderState()
export default {
  name: 'Folders',
  components: {
    FoldersEmpty,
    FoldersList,
    VueElementLoading
  },
  provide() {
    return {
      setPagination,
      paginationStore
    }
  },
  data() {
    return {
      foldersEmptyList: false,
      isLoading: false
    }
  },
  async mounted() {
    this.isLoading = true
  },
  methods: {
    folderEmpty(value) {
      this.foldersEmptyList = value
      this.isLoading= false
    }
  }
}
</script>
